import { Box, IconButton } from "@mui/material";
import React from "react";
import { TagList } from "../calendar";
import Slot from "./Slot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import {
  faChairOffice,
  faSprayCanSparkles,
} from "@fortawesome/pro-solid-svg-icons";
import CalendarStatus from "./CalendarStatus";
import CancelOrWaitAppointmentDialog from "./CancelOrWaitAppointmentDialog";
import { appointmentStep } from "shared/src/appointment.mjs";

const cleaningOverlaySteps = new Set([
  appointmentStep.PROCEDURE_NOTES,
  appointmentStep.CHAIR_CLEANING,
  appointmentStep.APPOINTMENT_FINISHED,
]);

const invisibleActiveSteps = new Set([
  appointmentStep.APPOINTMENT_FINISHED,
  appointmentStep.CHAIR_CLEANING,
]);

export default function CalendarSlot1({
  appointments,
  setChangeEmployee,
  status,
  setEditEvent,
}) {
  const [showCancelOrWaitDialog, setShowCancelOrWaitDialog] =
    React.useState(false);
  const slotProps = React.useMemo(() => {
    return {
      n: 1,
      appointments: appointments,
      setEditEvent: setEditEvent,
    };
  }, [appointments, setEditEvent]);

  const showCleaningOverlay = appointments.some((appointment) =>
    cleaningOverlaySteps.has(appointment.active_step),
  );

  const visibleAppointments = appointments.filter(
    (appointment) => !invisibleActiveSteps.has(appointment.active_step),
  );

  return (
    <>
      <Box display="flex">
        <TagList appointments={visibleAppointments} />
        <Slot variant={status} {...slotProps}>
          {showCleaningOverlay && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.45)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 5,
                cursor: "pointer",
              }}
            >
              <FontAwesomeIcon
                icon={faSprayCanSparkles}
                style={{
                  fontSize: "2.5rem",
                  color: "white",
                }}
              />
            </Box>
          )}

          {visibleAppointments.length !== 0 && setEditEvent != null && (
            <IconButton
              size="small"
              sx={{
                position: "absolute",
                top: "0",
                right: "0",
                padding: "0.2rem",
                zIndex: 10,
              }}
              onClick={async (e) => {
                e.stopPropagation();
                setShowCancelOrWaitDialog(true);
              }}
            >
              <FontAwesomeIcon icon={faXmark} fontSize="1rem" fixedWidth />
            </IconButton>
          )}

          {visibleAppointments.length === 0 ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <FontAwesomeIcon
                icon={faChairOffice}
                style={{ fontSize: "3.5rem" }}
              />
            </Box>
          ) : (
            <CalendarStatus
              appointments={visibleAppointments}
              setChangeEmployee={setChangeEmployee}
            />
          )}
        </Slot>
      </Box>
      {showCancelOrWaitDialog && (
        <CancelOrWaitAppointmentDialog
          appointments={visibleAppointments}
          close={() => setShowCancelOrWaitDialog(false)}
        />
      )}
    </>
  );
}
